import React from 'react';
import Carte from '../ui/Carte';

const INTITULE_FRAIS_DOSSIER = 'Frais de dossier et suivi d\'étude';

/**
 * Tableau de devis avec calcul automatique HT / TVA / TTC
 * Les lignes de phase sont liées aux phases définies en méthodologie
 */
function SectionDevis({ phases, fraisDossier, onChangerFraisDossier, onModifierPhase }) {
  const montantFrais = parseFloat(fraisDossier) || 0;

  const sousTotal = phases.reduce((acc, phase) => {
    const jeh = parseFloat(phase.nombreJeh) || 0;
    const prix = parseFloat(phase.prixUnitaire) || 0;
    return acc + jeh * prix;
  }, 0);

  const montantHT = montantFrais + sousTotal;
  const tva = montantHT * 0.2;
  const montantTTC = montantHT + tva;

  const formaterEuro = (val) =>
    val.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  return (
    <Carte titre="Tableau de devis" icone="💶">
      <div style={{ overflowX: 'auto' }}>
        <table className="tableau-devis">
          <thead>
            <tr>
              <th>Phases de l'étude</th>
              <th>Intitulé</th>
              <th>Prix unitaire HT (€)</th>
              <th>Nombre de JEH</th>
              <th>Montant HT</th>
            </tr>
          </thead>
          <tbody>
            {/* Frais fixes - montant forfaitaire, sans multiplication par les JEH */}
            <tr className="ligne-frais">
              <td></td>
              <td>{INTITULE_FRAIS_DOSSIER}</td>
              <td>
                <input
                  className="tableau-devis__input"
                  type="number"
                  value={fraisDossier}
                  onChange={(e) => onChangerFraisDossier(e.target.value)}
                  min="0"
                />
              </td>
              <td></td>
              <td>{montantFrais > 0 ? formaterEuro(montantFrais) : '-'}</td>
            </tr>

            {/* Phases dynamiques */}
            {phases.map((phase, idx) => {
              const jeh = parseFloat(phase.nombreJeh) || 0;
              const prix = parseFloat(phase.prixUnitaire) || 0;
              const montant = jeh * prix;

              return (
                <tr key={phase.id} className="ligne-phase">
                  <td>Phase {idx + 1}</td>
                  <td>{phase.designation || <em style={{ opacity: 0.5 }}>Sans titre</em>}</td>
                  <td>
                    <input
                      className="tableau-devis__input"
                      type="number"
                      value={phase.prixUnitaire || ''}
                      onChange={(e) => onModifierPhase(phase.id, 'prixUnitaire', e.target.value)}
                      placeholder="300"
                      min="0"
                    />
                  </td>
                  <td style={{ textAlign: 'right' }}>{jeh || '-'}</td>
                  <td>{montant > 0 ? formaterEuro(montant) : '-'}</td>
                </tr>
              );
            })}

            {/* Sous-total */}
            <tr className="tableau-devis__sous-total">
              <td colSpan={3}></td>
              <td>Sous-Total</td>
              <td>{formaterEuro(sousTotal)}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr className="tableau-devis__total-ht">
              <td colSpan={4}>Montant Total HT</td>
              <td>{formaterEuro(montantHT)}</td>
            </tr>
            <tr className="tableau-devis__tva">
              <td colSpan={4}>TVA (à titre indicatif, 20%)</td>
              <td>{formaterEuro(tva)}</td>
            </tr>
            <tr className="tableau-devis__total-ttc">
              <td colSpan={4}>Montant Total TTC</td>
              <td>{formaterEuro(montantTTC)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </Carte>
  );
}

export default SectionDevis;
